import { Link } from "react-router-dom";
import Slider from "react-slick";
import { config } from "../config";
import { ProductContext } from "../context/ProductsContext";
import { useContext } from "react";

const Category = () => {

  const { products, categories } = useContext(ProductContext);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } }
    ]
  };

  const imageUrl = config.imageUrl;

  return (
    <div className="container mx-auto py-2 px-4 mt-4">
      <Slider {...settings}>
        {/* Using map to loop through categories */}
        {categories.map((category) => {
          // Filter products by this category
          const productCount = products.filter((product) => product.category_id === category.id).length;
          return (
            <div key={category.id} className="relative px-2">
              <div className="relative group">
                {/* Add Link around the image */}
                <Link to={`/category/${category.id}`}>
                  <img
                    src={`${imageUrl}/${category.image}`}
                    alt={category.name}
                    className="w-full h-40 object-cover rounded-lg"
                  />
                  {/* Shadow Overlay */}
                  <div className="absolute inset-0 bg-black bg-opacity-50 group-hover:bg-green-500 group-hover:bg-opacity-90 rounded-lg transition duration-300"></div>
                  {/* Category Name and Product Count */}
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-white group-hover:opacity-100 transition-opacity duration-300">
                    <h2 className="text-lg font-bold text-center">{category.name}</h2>
                    <p className="text-sm">{productCount} Items</p>
                  </div>
                </Link>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Category;
